let arrOne = {
    '0': [
        {
            code: 'dailyBudget',
            id: 'dailyBudget',
            selected: true,
            isDefault: true,
            name: '每日预算',
            sortor: true,
        },
    ],
    '1': [
        { id: 3, code: 'imp', name: '展现量', isDefault: true, selected: true, sortor: true },
        { id: 4, code: 'click', name: '点击量', isDefault: true, selected: true, sortor: true },
        { id: 8, code: 'ctr', name: 'CTR', isDefault: true, selected: true, sortor: true },
    ],
    '2': [
        { id: 13, code: 'install', name: '安装量', isDefault: true, selected: true, sortor: true },
        { id: 14, code: 'installRate', name: '安装率', isDefault: true, selected: true, sortor: true },
        { id: 5, code: 'deal', name: '转化量', isDefault: true, selected: true, sortor: true },
        { id: 6, code: 'dealRate', name: '转化率', isDefault: true, selected: true, sortor: true },
        // { id: 15, code: 'amount', name: '收益', isDefault: true, selected: true, sortor: true },
        // { id: 16, code: 'ecpm', name: 'eCPM', isDefault: true, selected: true, sortor: true },
    ],
    '3': [
        { id: 9, code: 'cpm', name: 'CPM', isDefault: true, selected: true, sortor: true },
        { id: 10, code: 'cpc', name: 'CPC', isDefault: true, selected: true, sortor: true },
        { id: 12, code: 'cpa', name: 'CPA', isDefault: true, selected: true, sortor: true },
        { id: 2, code: 'spends', name: '花费', isDefault: true, selected: true, sortor: true },
    ],
};
let arrSec = {
    '0':[],
    '1':[
        { id:1,name: '账号ID', code: 'code',isDefault: true, selected: true, sortor: true },
        { id:2,name: '账号名称', code: 'name',isDefault: true, selected: true, sortor: true },
        { id:3,name: '账号名', code: 'email' ,isDefault: true, selected: true, sortor: true },
        { id:4,name: '竞价请求量', code: 'bid',isDefault: true, selected: true, sortor: true  },
        { id:5,name: '展现量', code: 'imp' ,isDefault: true, selected: true, sortor: true },
        { id:6,name: '点击量', code: 'click',isDefault: true, selected: true, sortor: true  },
        { id:7,name: 'CTR', code: 'ctr' ,isDefault: true, selected: true, sortor: true },
        { id:8,name: '安装量', code: 'install' ,isDefault: true, selected: true, sortor: true },
        { id:9,name: '安装率', code: 'installRate' ,isDefault: true, selected: true, sortor: true },
        { id:10,name: '转化量', code: 'deal' ,isDefault: true, selected: true, sortor: true },
        { id:11,name: '转化率', code: 'dealRate' ,isDefault: true, selected: true, sortor: true },
        { id:12,name: 'eCPM', code: 'ecpm',isDefault: true, selected: true, sortor: true  },
        { id:13,name: '收益', code: 'amount',isDefault: true, selected: true, sortor: true  },
    ]
    // '0': [
    //     // {
    //     //     code: 'dailyBudget',
    //     //     id: 'dailyBudget',
    //     //     selected: true,
    //     //     isDefault: true,
    //     //     name: '每日预算',
    //     //     sortor: true,
    //     // },
    //     // {
    //     //     code: 'bidPrice',
    //     //     id: 'bidPrice',
    //     //     selected: true,
    //     //     isDefault: true,
    //     //     name: '出价',
    //     //     sortor: true,
    //     // },
    // ],
    // '1': [
    //     // { id: 3, code: 'imp', name: '展现量', isDefault: true, selected: true, sortor: true },
    //     // { id: 4, code: 'click', name: '点击量', isDefault: true, selected: true, sortor: true },
    //     // { id: 8, code: 'ctr', name: 'CTR', isDefault: true, selected: true, sortor: true },
    // ],
    // '2': [
    //     // { id: 13, code: 'install', name: '安装量', isDefault: true, selected: true, sortor: true },
    //     // { id: 14, code: 'installRate', name: '安装率', isDefault: true, selected: true, sortor: true },
    //     // { id: 5, code: 'deal', name: '转化量', isDefault: true, selected: true, sortor: true },
    //     // { id: 6, code: 'dealRate', name: '转化率', isDefault: true, selected: true, sortor: true },
    //     // { id: 15, code: 'amount', name: '收益', isDefault: true, selected: true, sortor: true },
    //     // { id: 16, code: 'ecpm', name: 'eCPM', isDefault: true, selected: true, sortor: true },
    // ],
    // '3': [
    //     // { id: 9, code: 'cpm', name: 'CPM', isDefault: true, selected: true, sortor: true },
    //     // { id: 10, code: 'cpc', name: 'CPC', isDefault: true, selected: true, sortor: true },
    //     // { id: 12, code: 'cpa', name: 'CPA', isDefault: true, selected: true, sortor: true },
    //     // { id: 2, code: 'spends', name: '花费', isDefault: true, selected: true, sortor: true },
    // ],
};
let arrThr = {
    '0': [],
    '1': [
        { id: 3, code: 'imp', name: '展现量', isDefault: true, selected: true, sortor: true },
        { id: 4, code: 'click', name: '点击量', isDefault: true, selected: true, sortor: true },
        { id: 8, code: 'ctr', name: 'CTR', isDefault: true, selected: true, sortor: true },
    ],
    '2': [
        { id: 13, code: 'install', name: '安装量', isDefault: true, selected: true, sortor: true },
        { id: 14, code: 'installRate', name: '安装率', isDefault: true, selected: true, sortor: true },
        { id: 5, code: 'deal', name: '转化量', isDefault: true, selected: true, sortor: true },
        { id: 6, code: 'dealRate', name: '转化率', isDefault: true, selected: true, sortor: true },
        // { id: 15, code: 'amount', name: '收益', isDefault: true, selected: true, sortor: true },
        // { id: 16, code: 'ecpm', name: 'eCPM', isDefault: true, selected: true, sortor: true },
    ],
    '3': [
        { id: 9, code: 'cpm', name: 'CPM', isDefault: true, selected: true, sortor: true },
        { id: 10, code: 'cpc', name: 'CPC', isDefault: true, selected: true, sortor: true },
        { id: 12, code: 'cpa', name: 'CPA', isDefault: true, selected: true, sortor: true },
        { id: 2, code: 'spends', name: '花费', isDefault: true, selected: true, sortor: true },
    ],
};
export default { series: arrOne, group: arrSec, ad: arrThr };



// WEBPACK FOOTER //
// ./src/server/tablelist.js